import { useEffect, useRef, useState } from 'react';
import apiClient from '../services/apiClient';
import { getLanguage } from '../i18n';

export default function useLearningCoaching(context, { enabled = true, entryKey = '' } = {}) {
  const [language, setLanguage] = useState(getLanguage);
  const [loaded, setLoaded] = useState(null);
  const requests = useRef(new Map());
  const key = JSON.stringify([context, entryKey, language]);
  useEffect(() => {
    const changed = () => setLanguage(getLanguage());
    window.addEventListener('appLanguageChanged', changed);
    return () => window.removeEventListener('appLanguageChanged', changed);
  }, []);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    if (!requests.current.has(key)) {
      // Retain the request across Strict Mode effects, but not a new page entry.
      requests.current.set(key, Promise.resolve().then(() => apiClient.getLearningCoaching(context))
        .catch(() => ({ scenes: [], releaseId: null })));
    }
    requests.current.get(key).then(result => {
      if (!cancelled) setLoaded({ key, scenes: Array.isArray(result?.scenes) ? result.scenes : [], releaseId: result?.releaseId || null });
    });
    return () => { cancelled = true; };
  }, [context, enabled, key]);
  return enabled && loaded?.key === key ? loaded : { scenes: [], releaseId: null };
}
